import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Alert, Button, Input, ListGroup, ListGroupItem } from 'reactstrap';
import ErrorBoundary from './ErrorBoundary';
import NotAuthenticated from './NotAuthenticated';
import * as Accounts from '../store/Accounts';
import * as paths from '../data/Paths';
import * as Sites from '../store/Sites';
import * as utility from '../data/Utility';

class LinkSitesInternal extends React.Component {
    constructor(props) {
        super(props);

        const createStudy = utility.propCheck(props.createStudy, false);
        const sites = utility.propCheck(props.sites, []);
        const sponsor = utility.propCheck(props.sponsor, null);
        const studyName = utility.propCheck(props.studyName, "");
        this.state = {
            createStudy: createStudy,
            sites: sites,
            sponsor: sponsor,
            studyName: studyName
        };

        this.checkIfActive = this.checkIfActive.bind(this);
        this.getListGroup = this.getListGroup.bind(this);
        this.handleSelectClick = this.handleSelectClick.bind(this);
    }

    checkIfActive(site) {
        return this.state.sites.map(function (e) { return e.id; }).indexOf(site.id);
    }

    componentDidMount() {
        Accounts.checkAuthenticated(this.props.accountsState.authenticated, this.props.accountsDispatch);
        this.props.sitesDispatch.getAll();
    }

    getListGroup(allSites) {
        const listItems = allSites.map(site => {
            const active = this.checkIfActive(site) >= 0;
            return (
                <ListGroupItem key={site.id} active={active} tag="button" title={site.name} action onClick={this.handleSiteSelected.bind(this, site)}>
                    <div className="tab">
                        <Input className="input" type="checkbox" checked={active} readOnly />{' '}
                        {site.name}
                    </div>
                </ListGroupItem>
            );
        });

        return (
            <ListGroup>
                {listItems}
            </ListGroup>
        );
    }

    handleSelectClick() {
        var pathname = paths.study;
        const state = {
            create: this.state.createStudy,
            linkReturn: true,
            sites: this.state.sites,
            sponsor: this.state.sponsor,
            studyName: this.state.studyName
        };

        if (this.state.createStudy) {
            pathname = paths.createStudy;
        }

        this.props.history.push({
            pathname: pathname,
            state: state
        });
    }

    handleSiteSelected(site) {
        const active = this.checkIfActive(site);
        const sites = this.state.sites;

        if (active >= 0) {
            sites.splice(active, 1);
        }
        else {
            sites.push(site);
        }

        this.setState({
            sites: sites
        });
    }

    render() {
        if (!Accounts.authenticatedAdministrator(this.props.accountsState)) {
            return (
                <NotAuthenticated />
            );
        }

        const allSites = this.props.sitesState.all;
        var error = false;
        var listGroup = null;
        var message = "";
        const select = "Select";
        var studyName = this.state.studyName;

        if (studyName === "") {
            studyName = "{empty}";
        }

        if (allSites != null &&
            allSites.map != null) {
            listGroup = this.getListGroup(allSites);
        }
        else {
            error = true;
            message = "Error retrieving sites.";
        }

        const alertColor = error ? "danger" : "primary";
        const displayMessage = message !== "";

        return (
            <div>
                <h1>Link Sites<small> to study name '{studyName}'</small></h1>
                <div className="gap" />
                {displayMessage && <Alert color={alertColor}>{message}</Alert>}
                {listGroup}
                <div className="button-gap">
                    <Button className="button" title={select} onClick={this.handleSelectClick}>{select}</Button>
                </div>
            </div>
        );
    }
}

const LinkSitesConnect = withRouter(connect(
    state => ({
        accountsState: state.accounts,
        sitesState: state.sites
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch),
        sitesDispatch: bindActionCreators(Sites.actionCreators, dispatch)
    })
)(LinkSitesInternal));

export default class LinkSites extends React.Component {
    render() {
        var createStudy = false;
        var sites = [];
        var sponsor = null;
        var studyName = "";

        const propsState = this.props.location.state;
        if (propsState != null) {
            createStudy = utility.propCheck(propsState.createStudy, createStudy);
            sites = utility.propCheck(propsState.sites, sites);
            sponsor = utility.propCheck(propsState.sponsor, sponsor);
            studyName = utility.propCheck(propsState.studyName, studyName);
        }

        return (
            <ErrorBoundary>
                <LinkSitesConnect createStudy={createStudy} sites={sites} sponsor={sponsor} studyName={studyName} />
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/LinkSites.js